import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules } from '../data/content';
export function Modules() {
  return <section aria-label="Included modules" className="bg-graphite px-3 py-4 sm:px-6" data-id="element-131" data-mp="1r51250zgqi6v">
      <div className="mx-auto max-w-2xl space-y-2" data-id="element-132" data-mp="1vy3mqjm9ihax">
        {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-line bg-ink" data-id="element-133" data-mp="20woqgt0q3j44">
            <div className="flex items-center gap-1.5 bg-hazard px-2.5 py-1.5" data-id="element-134" data-mp="146o2uxc3b8oe">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-ink" strokeWidth={3} aria-hidden="true" data-id="element-135" data-mp="1877xnu96y07d" />
              <h3 className="font-display text-[0.68rem] font-extrabold uppercase leading-tight text-ink sm:text-[0.86rem]" data-id="element-136" data-mp="1d61dvufv45b8">
                MODULE {mod.number} — {mod.title}
              </h3>
            </div>
            <p className="px-2.5 py-2 text-[0.78rem] leading-[1.35] text-steel sm:text-[0.92rem]" data-id="element-137" data-mp="2omj071pqwrk5">{mod.body}</p>
          </article>)}
      </div>
    </section>;
}